import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Sun } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/", { replace: true });
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        setUser(r.data.user);
        // seed demo data on first login
        try {
          await api.post("/demo/seed");
        } catch (seedErr) {
          if (process.env.NODE_ENV !== "production") console.warn("Demo seed skipped", seedErr);
        }
        // Phase 4.2 — Conversion-Funnel: Portal-Login tracken, falls vorgemerkt
        try {
          const portalSlug = sessionStorage.getItem("pending_portal_login");
          if (portalSlug) {
            await api.post("/agency/track-portal-login", { portal_slug: portalSlug });
            sessionStorage.removeItem("pending_portal_login");
          }
        } catch { /* noop — tracking ist non-blocking */ }
        // /auth/me liefert {user, company, agency}. Wir entscheiden direkt anhand der Response.
        const me = await api.get("/auth/me");
        const agency = me.data?.agency;
        const userData = me.data?.user;
        // honor ?next= z.B. von /invite/{token}
        const nextParam = new URLSearchParams(window.location.search).get("next");
        let target = "/dashboard";
        if (nextParam && nextParam.startsWith("/")) {
          target = nextParam;
        } else if (
          agency &&
          agency.onboarding_completed === false &&
          (userData?.role === "agency_admin" || userData?.role === "platform_admin")
        ) {
          target = "/agency/onboarding";
        }
        await checkAuth();
        window.history.replaceState(null, "", target);
        nav(target, { replace: true });
      } catch (e) {
        if (process.env.NODE_ENV !== "production") console.error("Auth failed", e);
        nav("/", { replace: true });
      }
    })();
  }, [nav, setUser, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 rounded-xl bg-orange-500 flex items-center justify-center animate-pulse">
          <Sun className="w-6 h-6 text-white" />
        </div>
        <p className="text-sm text-slate-600">Anmeldung wird abgeschlossen …</p>
      </div>
    </div>
  );
}
